// Set up initial value for each cards
export default function initialCards() {
  return [
    {
      text: `Play for fun, not to make money`,
      value: 'forFun',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'positive',
    },
    {
      text: 'Trying to win back losses can be a lose, lose-again situation',
      value: 'backLosses',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'positive',
    },
    {
      text: `Taking a break is a smart choice`,
      value: 'takeBreak',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'positive',
    },
    {
      text:  `It's good to balance gambling with other activities`,
      value: 'balanceGambling',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'positive',
    },
    {
      text:  `If I play long enough, I can win back all of the money I've lost`,
      value: 'playLong',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'negative',
    },
    {
      text: `If I play at the same slot machine all evening, it must be due for a win`,
      value: 'sameSlotMachine',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'negative',
    },
    {
      text: `Sitting in the same seat each time I play will improve my chances of winning`,
      value: 'sameSeat',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'negative',
    },
    {
      text: `Having a lucky charm will improve my chances of winning`,
      value: 'luckyCharm',
      flipped: false,
      locked: true,
      pinned: false,
      reversed: null,
      counter: 0,
      behavior: 'negative',
    },
  ]
}



// WEBPACK FOOTER //
// ./src/components/rlgl/Game/GameData.js